/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createAdditionalQuestionDataSubtypeSchema } from './CreateAdditionalQuestionDataSubtypeSchema'
import { createAdditionalQuestionDataTypeSchema } from './CreateAdditionalQuestionDataTypeSchema'

export const createAdditionalQuestionDataSchema = z.object({
	label: z.string(),
	type: createAdditionalQuestionDataTypeSchema,
	subtype: createAdditionalQuestionDataSubtypeSchema.nullable().optional(),
	validationRules: z.array(z.string()).nullable().optional(),
	options: z.array(
		z.object({
			id: z.string().nullable(),
			label: z.string(),
			position: z.number(),
			isDisqualifying: z.boolean().nullable().default(false),
			scoreValue: z.number().nullable(),
			consentType: z.string().nullable(),
		}),
	).nullable().optional(),
	position: z.number(),
	targetScoreRanges: z.array(z.string()).nullable().optional(),
})

export type CreateAdditionalQuestionDataSchema = z.infer<typeof createAdditionalQuestionDataSchema>
